import { createFileRoute } from '@tanstack/react-router'
import SimpleClassesView from '@/components/teacherPage/SimpleClassesView'
import { guardTeacherOnly } from '@/lib/auth/routeGuards'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/teacher/classes')({
  component: ClassesComponent,
  beforeLoad: guardTeacherOnly,
})

function ClassesComponent() {
  const { t } = useTranslation()
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-3xl font-bold mb-6">
        {t('routes.teacher-folder.classes.title')}
      </h1>
      <SimpleClassesView />
    </div>
  )
}
